import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StorageWarningComponent } from '@app/shared/storage-warning/storage-warning.component';

@NgModule({
  declarations: [StorageWarningComponent],
  imports: [CommonModule],
  exports: [StorageWarningComponent],
})
export class StorageWarningModule {}
